import smartIdeDialogTemplate from './smart-ide-dialog.tpl.html';
import './smart-ide-dialog.less';
import { modalComponentModule } from '../modal/modal';
import { WORKSPACE_STATUS } from '../../services/codemirror-workspace-service/codemirror-workspace-service';
import { userFeedbackModelModule } from '../../models/user-feedback-model';
import { userFeedbackFormComponentModule } from '../user-feedback-form/user-feedback-form';

export const smartIdeDialogComponentModule = angular
  .module('Q.components.smart-ide-dialog', [
    modalComponentModule,
    userFeedbackModelModule,
    userFeedbackFormComponentModule,
  ])

  .factory('smartIdeDialog', function ($modal, UserFeedback) {
    return {
      /**
       * Opens a new iFrame dialog.
       *
       * @returns {{result:Promise, opened:Promise, closed:Promise, close:Function, dismiss:Function, reload:Function, setUrl:Function}} modalInstance
       */
      open(mfc) {
        return $modal.openOnce('smartIdeDialog', {
          template: smartIdeDialogTemplate,
          controller: 'SmartIdeDialogCtrl as $ctrl',
          windowClass: `smart-ide-dialog`,
          allowDarkMode: true,
          size: 'lg',
          resolve: {
            mfc: () => mfc,
            userFeedback: () => {
              if (mfc) {
                return UserFeedback.findExisting({
                  feedbackType: 'feature',
                  featureName: 'SmartIDE',
                  solution: mfc.solution,
                  challenge: mfc.challenge,
                });
              }
            },
          },
        });
      },
    };
  })

  .controller(
    'SmartIdeDialogCtrl',
    function SmartIdeDialogCtrl($scope, $modalInstance, mfc, userFeedback) {
      const ctrl = this;

      ctrl.status = mfc.workspaceStatusAction;

      ctrl.existingUserFeedback = userFeedback;
      ctrl.solution = mfc.solution;
      ctrl.challenge = mfc.challenge;

      ctrl.restartSmartIde = () => mfc.restartSmartIde();

      Object.defineProperties(ctrl, {
        smartIdeEnabled: {
          get() {
            return !!(mfc.workspace && mfc.workspace.enabled);
          },
          set(val) {
            mfc.toggleSmartIde(val);
          },
        },
        disabled: {
          get() {
            return (
              mfc.workspace &&
              mfc.workspace.status === WORKSPACE_STATUS.DESTROYING
            );
          },
        },
      });
    },
  );
